import styled from "styled-components"

export const EducationCardWrapper = styled.div`
  padding: 15px 20px;
  border-radius: 8px;
  background: linear-gradient(rgb(231, 241, 252), rgb(208, 228, 249));
  border: 1px solid rgb(53, 120, 200);
`
